import Icon from 'components/Icon';
import {FilterHint} from 'plugins/modules/filter/components/FilterHint';
import classNames from 'classnames';
import React, {Children, FC, ReactNode, useState} from 'react';
import style from './style.module.scss';

interface IProps {
    children: ReactNode;
    hint?: string;
    isDefaultOpen: boolean;
    title: string;
}

export const FilterCollapse: FC<IProps> = ({children, hint, isDefaultOpen, title}) => {
    const [isVisible, setIsVisible] = useState(isDefaultOpen);

    const toggle = () => {
        setIsVisible((visibility) => !visibility);
    };

    if (!Children.toArray(children).flat().length) {
        return null;
    }

    return (
        <div
            className={classNames(style.collapseContainer, {
                [style.active]: isVisible,
            })}
        >
            {title && (
                <button className={style.button} onClick={toggle} type={'button'} data-skeleton-item={true}>
                    <span className={style.title}>{title}</span>
                    {hint && <FilterHint text={hint} />}
                    <Icon className={style.icon} icon={'arrow-collapse'} />
                </button>
            )}
            <div className={style.contentBlock}>{children}</div>
        </div>
    );
};
